import Semester from "../../../../../components/categories/siakad/lms/data_semester/Home";
export default function Home() {
  
  return (
    <Semester />
  );
}
